export default function stateListAllQuery() {
  const query = '{stateListAll{id, name, uf}}';
  return query;
}
